import React, { useEffect, useCallback, useState, useRef } from 'react';
import cx from 'classnames';
import LoadingProps from './Loading.types';
import styles from './Loading.module.scss';
import Spinner from '../Spinner/index';

const Loading = ({ isLoading, loaderText, intervalLength = 10000, dataCy, className }: LoadingProps) => {
  const isArray = Array.isArray(loaderText);
  const messageIndex = useRef<number>(0);
  const initalMessage = isArray ? loaderText[messageIndex.current] : loaderText;
  const [message, setMessage] = useState<string>(initalMessage || '');

  const changeMessage = useCallback(() => {
    messageIndex.current += 1;
    if (messageIndex.current >= loaderText.length) messageIndex.current = 0;
    setMessage(loaderText[messageIndex.current]);
  }, []);

  useEffect(() => {
    if (isLoading && isArray) {
      const interval = setInterval(changeMessage, intervalLength);
      return () => clearInterval(interval);
    }
    return () => null;
  }, [changeMessage, isLoading]);

  const loader = (
    <div className={cx(styles.loading, className)} data-cy={dataCy} data-testid={dataCy}>
      <div>
        <Spinner className={styles.spinner} />
        <span key={message} className={styles.fadeInMessage}>
          {message}
        </span>
      </div>
    </div>
  );

  return isLoading ? loader : null;
};

export default Loading;
